import { PaymentsService_paymentsV2ServiceGetGet } from '@festina/moneyin-general-types/moneyin/hooks/PaymentsService_paymentsV2ServiceGetGet'

export const useFetchPayment =
  PaymentsService_paymentsV2ServiceGetGet.useSuspenseQuery
